module.exports = __webpack_public_path__ + "94192b2931aee17bfe227d85e11339d0.png";